import { PropsWithChildren } from 'react';

import { Card } from '@@/primitives/Card';

export function AuthCard({ children }: PropsWithChildren<unknown>) {
  return (
    <Card.Container shadow>
      <Card.Body className="px-6 py-5">{children}</Card.Body>
    </Card.Container>
  );
}
